import * as types from '../const/action.types';

export function visibility(state = {}, action) {
    switch (action.type) {
        case types.LOAD_VISIBILITY_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function visibilityHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.VISIBILITY_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function visibilityIsLoading(state = false, action) {
    switch (action.type) {
        case types.VISIBILITY_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/visibility.reducer.js